const env = (import.meta as any)?.env || {};

const BACKEND_BASE_URL =
  env.VITE_BACKEND_BASE_URL ||
  env.VITE_FUNCTIONS_BASE_URL ||
  'https://mintleaf-foglalasok-4-ai-copy.onrender.com';

const DEFAULT_TIMEOUT_MS = 3500;
const DEFAULT_COOLDOWN_MS = 45_000;

let inflightWarmup: Promise<void> | null = null;
let lastWarmupAt = 0;

const withTimeout = async (timeoutMs: number): Promise<void> => {
  const controller = new AbortController();
  const timeoutHandle = globalThis.setTimeout(() => controller.abort(), timeoutMs);

  try {
    await fetch(`${BACKEND_BASE_URL}/health`, {
      method: 'GET',
      cache: 'no-store',
      signal: controller.signal,
    });
  } finally {
    globalThis.clearTimeout(timeoutHandle);
  }
};

export const warmBackend = async (
  options: { timeoutMs?: number; cooldownMs?: number; force?: boolean } = {}
): Promise<void> => {
  const timeoutMs = options.timeoutMs ?? DEFAULT_TIMEOUT_MS;
  const cooldownMs = options.cooldownMs ?? DEFAULT_COOLDOWN_MS;
  const now = Date.now();

  if (!options.force && now - lastWarmupAt < cooldownMs) {
    return;
  }

  if (inflightWarmup) {
    return inflightWarmup;
  }

  inflightWarmup = withTimeout(timeoutMs)
    .catch(() => {
      // best effort wake-up: intentionally swallow warm-up failures
    })
    .finally(() => {
      lastWarmupAt = Date.now();
      inflightWarmup = null;
    });

  return inflightWarmup;
};

export const __resetWarmBackendForTests = () => {
  inflightWarmup = null;
  lastWarmupAt = 0;
};
